import React from 'react'
import { COLORS } from '../../../constants'
import PnlPrice from '../../PositionColumns/PnlPrice'
import TranslateText from '../../TranslateText'
import { Button, Tag, message } from 'antd'
import { Text, View } from '../../../../styles/reactnative'
import { from } from 'rxjs'
import EntryTime from '../../PositionColumns/EntryTime'
import UserTag from '../../UserTag'
import { title } from 'process'
import KrwPrice from '../../PositionColumns/KrwPrice'
import API from '../../../../utils/api'

export const column_wallet_page = (mutate, openModal, token) => {
	return [
		{
			title: '시간',
			dataIndex: 'sent_at',
			key: 'sent_at',
			align: 'center',
			width: 115,
			render: (text, record) => (
				<EntryTime time={text} relative={true} relativeAdd={true} />
			),
		},
		{
			title: '회원',
			dataIndex: 'user_id',
			key: 'user_id',
			align: 'center',
			width: 115,
			render: (text, record) => (
				<UserTag
					userid={text}
					email={record?.email}
					phone={record?.phone}
					nickname={record?.fullname || record?.nickname}
					onClick={() => {
						openModal(text)
					}}
				/>
			),
		},
		{
			title: '내역',
			dataIndex: 'detail',
			width: 140,
			align: 'center',
			key: 'detail',
			render: (text, record) => <TranslateText text={text} />,
		},

		{
			title: '수량',
			dataIndex: 'amountsymbol',
			align: 'center',
			key: 'amountsymbol',
			render: (text, record) => (
				<PnlPrice
					price={record?.amount}
					ep_id={record?.exchange_pairs_id}
					dp={0}
					krw={true}
				/>
			),
		},
		{
			title: '별도입출사유',
			dataIndex: 'adminmemo',
			align: 'center',
			key: 'adminmemo',
			render: (text, record) => <Text>{text}</Text>,
		},
		{
			title: '출금락',
			dataIndex: 'lockcount',
			align: 'center',
			key: 'lockcount',
			render: (text, record) => (
				<>
					{text ? (
						<>
							<Text>{text ? text + '회' : ''}</Text>
							<Button
								size="small"
								onClick={() => {
									API.delete('/admin/lockcount', token + '', {
										id: record?.id,
									}).then(res => {
										mutate()
										message.success('출금락 해제')
									})
								}}>
								제거
							</Button>
						</>
					) : (
						<></>
					)}
				</>
			),
		},
		{
			title: '잔고',
			children: [
				{
					title: '이전',
					dataIndex: 'beforeamount',
					align: 'center',
					key: 'adminmemo',
					render: (text, record) => <KrwPrice price={text} />,
				},
				{
					title: '이후',
					dataIndex: 'afteramount',
					align: 'center',
					key: 'adminmemo',
					render: (text, record) => <KrwPrice price={text} />,
				},
			],
		},
		{
			title: '분석데이터(개발자)',
			dataIndex: 'info',
			align: 'center',
			key: 'info',
			render: (text, record) => (
				<Text style={{ color: '#aaa', fontSize: 10 }}>{text}</Text>
			),
		},
	]
}
